"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var IfscTopBonus_1 = require("./scoreSystems/IfscTopBonus");
var IfscTopZone_1 = require("./scoreSystems/IfscTopZone");
var IfscLead_1 = require("./scoreSystems/IfscLead");
var NorthFaceCup2019_1 = require("./scoreSystems/NorthFaceCup2019");
var PointsDecreaseWithAttempts_1 = require("./scoreSystems/PointsDecreaseWithAttempts");
var PointsGravical2019_1 = require("./scoreSystems/PointsGravical2019");
var TopsWithAttempts_1 = require("./scoreSystems/TopsWithAttempts");
var UsacModifiedRedpoint_1 = require("./scoreSystems/UsacModifiedRedpoint");
var UsacModifiedRedpointMultizone_1 = require("./scoreSystems/UsacModifiedRedpointMultizone");
exports.default = {
    IfscTopBonus: IfscTopBonus_1.default,
    IfscTopZone: IfscTopZone_1.default,
    IfscLead: IfscLead_1.default,
    NorthFaceCup2019: NorthFaceCup2019_1.default,
    PointsDecreaseWithAttempts: PointsDecreaseWithAttempts_1.default,
    PointsGravical2019: PointsGravical2019_1.default,
    TopsWithAttempts: TopsWithAttempts_1.default,
    UsacModifiedRedpoint: UsacModifiedRedpoint_1.default,
    UsacModifiedRedpointMultizone: UsacModifiedRedpointMultizone_1.default,
};
__export(require("./constants"));
__export(require("./getAppButtons"));
function getScoreSystem(key, round, routes) {
    switch (key) {
        case constants_1.IFSC_TB:
            return new IfscTopBonus_1.default({ round: round, routes: routes });
        case constants_1.IFSC_TZ:
            return new IfscTopZone_1.default({ round: round, routes: routes });
        case constants_1.IFSC_LEAD:
            return new IfscLead_1.default({ round: round, routes: routes });
        case constants_1.NORTH_FACE_CUP_2019:
            return new NorthFaceCup2019_1.default({ round: round, routes: routes });
        case constants_1.POINTS_DECREASE:
            return new PointsDecreaseWithAttempts_1.default({ round: round, routes: routes });
        case constants_1.POINTS_GRAVICAL_2019:
            return new PointsGravical2019_1.default({ round: round, routes: routes });
        case constants_1.TOPS_WITH_ATTEMPTS:
            return new TopsWithAttempts_1.default({ round: round, routes: routes });
        case constants_1.USAC_MOD_REDPOINT:
            return new UsacModifiedRedpoint_1.default({ round: round, routes: routes });
        case constants_1.USAC_MOD_REDPOINT_MULTIZONE:
            return new UsacModifiedRedpointMultizone_1.default({ round: round, routes: routes });
        default:
            throw new Error("Unrecognized score system: \"" + key + "\"");
    }
}
exports.getScoreSystem = getScoreSystem;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/index.js
// module id = 58
// module chunks = 0